import { useState, useEffect } from 'react';

import defaultConfig from '../utils/config';

export function useConfig() {
  const [config, setConfig] = useState<any>(undefined);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    if (config === undefined) {
      return;
    }

    setIsLoaded(true);
  }, [config]);

  useEffect(() => {
    if (__DEV__) {
      setConfig(defaultConfig);
    } else {
      fetch('/config.json')
        .then((data) => data?.json())
        .then((c) => setConfig(c))
        .catch((e) => setConfig(null));
    }
  }, []);

  return { config, isLoaded };
}
